import React from 'react';
import PropTypes from 'prop-types';
import { AButton, AIconButton } from '../../atoms';

const OConfirmPopup = (props) => {
	if (!props.open) {
		return null;
	}
	const handleChildClick = (event) => {
		event.stopPropagation();
	};
	return (
		<section className="o-popup--confirm" onClick={props.onCancel} role="presentation">
			<article
				className="o-pop-up--confirm"
				onClick={handleChildClick}
				role="presentation"
			>
				<header className="o-pop-up-confirm--header">
					<h3> {props.title}</h3>
					<AIconButton
						type="close"
						className="no-color close"
						onClick={props.onCancel}
					/>
				</header>
				<article className="o-pop-up--confirm-body">
					<p>{props.text}</p>
				</article>
				<footer className="o-pop-up--confirm-footer">
					<AButton
						value={props.confirmLabel}
						onClick={props.onConfirm}
					/>
					<AButton
						value={props.cancelLabel}
						onClick={props.onCancel}
						type="destructive"
					/>
				</footer>
			</article>
		</section>
	);
};

OConfirmPopup.propTypes = {
	onConfirm: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	confirmLabel: PropTypes.string.isRequired,
	cancelLabel: PropTypes.string.isRequired,
	open: PropTypes.bool,
};

OConfirmPopup.defaultProps = {
	open: false,
};

export default OConfirmPopup;



// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.confirm-popup.js